// extracted by mini-css-extract-plugin
export default {"brand":"AppShell_brand__9MMVV","logo":"AppShell_logo__EffJ1","rail":"AppShell_rail__CM56J","bar":"AppShell_bar__g3Yaw"};